import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Play, Lock } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { VideoThumbnail } from "@/components/VideoThumbnail";
import { VideoPlayer } from "@/components/VideoPlayer";
import { thumbUrl } from "@/lib/api";

export function RecordingCard({ recording, playbackPath, refreshPath }) {
  const [open, setOpen] = useState(false);
  const available = recording.status === "tersedia" && !!recording.video_url;
  const hidden = recording.status === "disembunyikan";

  return (
    <>
      <Card className="glass-card glass-card-hover overflow-hidden" data-testid={`recording-card-${recording.id}`}>
        <VideoThumbnail
          thumbnailUrl={thumbUrl(recording.thumbnail_image, recording.updated_at)}
          hasVideo={!!recording.video_url}
          status={recording.status}
          onClick={() => available && setOpen(true)}
          testId={`recording-thumbnail-${recording.id}`}
        />
        <CardContent className="p-5">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-heading font-semibold text-base">{recording.title}</h3>
            <StatusBadge status={recording.status} />
          </div>
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed line-clamp-2">
            {recording.description || "This session recording will be uploaded by admin after class ends."}
          </p>
          <Button
            className="w-full mt-4"
            disabled={!available}
            variant={available ? "default" : "outline"}
            onClick={() => available && setOpen(true)}
            data-testid={`recording-watch-${recording.id}`}
          >
            {available ? <Play className="h-4 w-4" /> : <Lock className="h-4 w-4" />}
            {available ? "Watch" : hidden ? "Not Available" : "Coming Soon"}
          </Button>
        </CardContent>
      </Card>
      {available && <VideoPlayer recording={recording} open={open} onOpenChange={setOpen} playbackPath={playbackPath} refreshPath={refreshPath} />}
    </>
  );
}
